var frFR = {
  locale: 'fr_FR',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Janv', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
    monthList: ['Janv', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
    shortDayList: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayList: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    shortestDayList: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa']
  },
  'dynamic-date': {
    day: 'Jour',
    week: 'Semaine',
    month: 'Mois',
    quarter: 'Trimestre',
    year: 'Année',
    before: 'Avant ${value}${unit}'
  },
  'auto-complete.empty': 'Aucune donnée',
  'select.selected-count': '${count} éléments sélectionnés',
  'date-time-picker.date': 'Sélectionner la date',
  'image-view.zoom-out': 'Zoom arrière',
  'input.placeholder': 'Veuillez effectuer une saisie',
  'empty.text': 'Aucune donnée',
  'date-picker.cancel': 'Annuler',
  'date-picker.end': 'Date de fin',
  'cascader.empty': 'Aucune donnée',
  'upload.drop': 'Faites glisser des fichiers ici ou',
  'color.custom': 'Personnaliser la couleur',
  'cascader.titles': ['Niveau 1', 'Niveau 2', 'Niveau 3', 'Niveau 4', 'Niveau 5', 'Niveau 6', 'Niveau 7', 'Niveau 8'],
  'date-comparison.error-target': 'Sélectionner la date de fin pour la comparaison',
  'transfer.empty': 'Aucune donnée',
  'select.search.placeholder': 'Veuillez effectuer une saisie',
  'upload.click': 'Cliquer pour télécharger',
  'date-time-picker.placeholder': 'Veuillez effectuer une saisie',
  'pager.jump': 'Redirection',
  'tree-select.placeholder': 'Veuillez effectuer une saisie',
  'dynamic-date.interval': 'Intervalle',
  'modal.cancel': 'Annuler',
  'image-view.rotate': 'Pivoter',
  'tabs.more': 'Plus',
  'popover.ok': 'Confirmer',
  'transfer.placeholder': 'Veuillez effectuer une saisie',
  'date.month': 'Mois',
  'select.selected': 'Sélection',
  'popover.cancel': 'Annuler',
  'image-view.prev': 'Précédent',
  'table.emptyText': 'Aucune donnée',
  'date-time-picker.ok': 'Confirmer',
  'table.filter.confirm': 'Confirmer',
  'tree-select.empty': 'Aucune donnée',
  'dynamic-date.fixed-date': 'Date fixe',
  'date-comparison.compare': 'Comparer',
  'auto-complete.placeholder': 'Veuillez effectuer une saisie',
  'time-picker.placeholder': "Sélectionner l'heure",
  'date.month-first': true,
  'select.clear': 'Effacer',
  'date.year': '${year}',
  'date-comparison.yoy': "Cette période l'année dernière",
  'image-view.zoom-to-origin': "Taille d'origine",
  'schedule.title': 'Date/heure',
  'schedule.clear': 'Effacer',
  'date-time-picker.end': "Sélectionner la date et l'heure de fin",
  'dynamic-date.customize': 'Personnaliser',
  'date-picker.apply': 'Appliquer',
  'schedule.selected': 'Date sélectionnée',
  'dynamic-date.dynamic-date': 'Date dynamique',
  'select.placeholder': 'Veuillez effectuer une sélection',
  'schedule.separator': ',',
  'cascader.search': 'Veuillez effectuer une saisie',
  'date-picker.invalid-range': 'La période sélectionnée dépasse la plage sélectionnable. Veuillez sélectionner une période valide.',
  'dynamic-date.date-preview': 'Aperçu de la date',
  'select.empty': 'Aucune donnée',
  'image-view.next': 'Suivant',
  'date-time-picker.now': 'Maintenant',
  'date-time-picker.time': "Sélectionner l'heure",
  'tree.empty': 'Aucune donnée',
  'pager.total': '${total} enregistrements au total',
  'image-view.zoom-in': 'Zoom avant',
  'date-picker.placeholder': 'Sélectionner la date',
  'textarea.placeholder': 'Veuillez effectuer une saisie',
  'date.week': 'Semaine',
  'pager.size': '${count} enregistrements/page',
  'modal.ok': 'Confirmer',
  'date-picker.start': 'Date de début',
  'table.filter.reset': 'Réinitialiser',
  'image-view.zoom-to-fit': 'Ajuster',
  'pager.page.placeholder': 'Veuillez effectuer une saisie',
  'select.select-all': 'Sélectionner tout',
  'list-viewer.empty': 'Aucune donnée',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'Liste source',
  'date-time-picker.start': "Sélectionner la date et l'heure de début",
  'date-comparison.error-source': 'Sélectionner la date de début de la comparaison',
  'upload.error.overflow-count': 'Nombre maximum de fichiers dépassé',
  'date-comparison.placeholder': 'Date de début - Date de fin',
  'time-range-picker.placeholder': 'Heure de début - Heure de fin',
  'date-comparison.mom': 'Par rapport à la période précédente',
  'transfer.target': 'Liste cible'
};
export default frFR;